import { Component, OnInit, OnDestroy } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { EmailIds } from 'src/app/helpers/emailId';
import { EmailReminderService } from 'src/app/services/email-reminder.service';
import { environment } from 'src/environments/environment';
import { AlertComponent } from '../../alert/alert.component';
import * as $ from 'jquery';
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/autocomplete';
import Quill from 'quill';

declare const tinymce: any;

declare global {
  interface JQuery {
    autocomplete(options?: any): JQuery;
    draggable(options?: any): JQuery;
    modal(options?: any): JQuery;
    tagsInput(options?: any): JQuery;
    removeTag(value: string): JQuery;
    importTags(value: string): JQuery;
  }
}

@Component({
  selector: 'app-summernote',
  templateUrl: './summernote.component.html',
  styleUrls: ['./summernote.component.css']
})
export class SummernoteComponent implements OnInit, OnDestroy {
  private quill: Quill;
  private routeParamSub?: Subscription;
  constructor(private activatedRoute: ActivatedRoute,private router: Router,
    private emailReminderService: EmailReminderService,private alert: AlertComponent) {
    // Initialize available options
    this.availableToOptions = [...this.availableOptions];
    this.availableCcOptions = [...this.availableOptions];
  }
  usersKey: any;
  ToEmails: any;
  CcEmails: any;
  isFileDeleted: any;
  ToEmailsVal: any;
  CcEmailsVal: any;
  IsUpsiEmail: boolean;
  filesToUpload: any;
  DocumentFileDoc: any;
  missingBodyKeywords: string;
  missingSubjectKeywords: string;
  keywordsMissingBodyAlert: boolean;
  keywordsMissingSubjectAlert: boolean;
  aryBodyKeyWords: string[] = [];
  arySubjectKeyWords: string[] = [];
  bodyKeyWords: string = '';
  subjectKeyWords: string = '';
  emailReminderId: string;
  companyId: string;
  mailReminderStaticID: string;
  reminderMasterForm: FormGroup;
  isDefault: boolean;
  IsSubjectKeyWordRequired: boolean;
  IsBodyKeyWordRequired: boolean;
  FileNameO: any;
  disabledOnclick: boolean = false;
  downloadURLForUPSI: any = environment.pssServerUrl + "upsi/EmailDoc/";
  error: any = { isError: false, errorMessage: '' };
  showSuccessPopup: boolean = false;
  type:any;
  dtTrigger: Subject<any> = new Subject();
  reminders: any[];
  editorConfig = {
    theme: 'snow',
    modules: {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],
        [{ 'indent': '-1'}, { 'indent': '+1' }],
        [{ 'direction': 'rtl' }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'font': [] }],
        [{ 'align': [] }],
        ['clean'],
        ['link', 'image', 'video']
      ]
    }
  };
  // Add new properties
  availableOptions = ['Sharer', 'Recipient', 'Data entry person', 'ADMIN', 'UPSI All data'];
  availableToOptions: string[] = [];
  availableCcOptions: string[] = [];
  selectedToEmails: string[] = [];
  selectedCcEmails: string[] = [];
  toInputValue: string = '';
  ccInputValue: string = '';
  toEmailError: string = '';
  ccEmailError: string = '';
  showToDropdown: boolean = false;
  showCcDropdown: boolean = false;

  // Getter to filter out already selected items from dropdown
  get filteredToOptions(): string[] {
    // Always use the original availableOptions and filter out selected items
    // This ensures the dropdown always shows all available options except those already selected
    return this.availableOptions.filter(option => 
      !this.selectedToEmails.includes(option) && !this.selectedCcEmails.includes(option)
    );
  }

  // Getter to filter out already selected items from CC dropdown
  get filteredCcOptions(): string[] {
    // Always use the original availableOptions and filter out selected items
    return this.availableOptions.filter(option => 
      !this.selectedToEmails.includes(option) && !this.selectedCcEmails.includes(option)
    );
  }

  // TrackBy function for better rendering performance
  trackByOption(index: number, option: string): string {
    return option;
  }

  ngOnInit(): void {
    // Initialize form first
    this.reminderMasterForm = new FormGroup({
      Title: new FormControl('', [Validators.required]),
      Subject: new FormControl('', [Validators.required, this.noSpecialCharactersValidator]),
      EmailText: new FormControl(''),
      Body: new FormControl('')
    });

    setTimeout(() => {
      this.initializeQuill();
    }, 0);

    this.routeParamSub = this.activatedRoute.paramMap
      .pipe(
        map((pm) => pm.get('emailReminderId')),
        filter((raw): raw is string => !!raw),
        distinctUntilChanged()
      )
      .subscribe((raw) => {
        try {
          const decoded = JSON.parse(decodeURIComponent(raw));
          this.emailReminderId = decoded[0].emailReminderId;
          this.type = decoded[1].type;
        } catch {
          return;
        }
        this.loadEmailReminderData(this.emailReminderId);
      });
  }

  /**
   * Replace unresolved template placeholders and flatten table markup so Quill 2
   * does not throw (TableRow.optimize / formats is not a function on email HTML).
   */
  private sanitizeBodyHtmlForEditor(html: string): string {
    if (!html || typeof html !== 'string') {
      return '';
    }
    const origin =
      typeof window !== 'undefined' && window.location && window.location.origin
        ? window.location.origin + '/'
        : '/';
    let s = html
      .replace(/\{HeaderUrl\}/gi, origin)
      .replace(/\{FooterUrl\}/gi, origin)
      .replace(/\{HeaderURL\}/gi, origin)
      .replace(/\{FooterURL\}/gi, origin);

    if (typeof DOMParser === 'undefined') {
      return s;
    }
    try {
      const doc = new DOMParser().parseFromString(`<div class="sanitize-root">${s}</div>`, 'text/html');
      const root = doc.body.querySelector('.sanitize-root');
      if (!root) {
        return s;
      }
      // Innermost tables first — processing outer tables first duplicates nested <table> content.
      while (true) {
        const tables = Array.from(root.querySelectorAll('table'));
        const leaf = tables.find((t) => !(t as HTMLTableElement).querySelector('table')) as
          | HTMLTableElement
          | undefined;
        if (!leaf) {
          break;
        }
        const wrap = doc.createElement('div');
        wrap.className = 'email-body-table-flat';
        leaf.querySelectorAll('tr').forEach((tr) => {
          tr.querySelectorAll('td, th').forEach((cell) => {
            const p = doc.createElement('p');
            p.innerHTML = cell.innerHTML;
            wrap.appendChild(p);
          });
        });
        leaf.replaceWith(wrap);
      }
      this.dedupeConsecutiveImageOnlyParagraphs(root);
      return root.innerHTML;
    } catch {
      return s;
    }
  }

  /**
   * Remove stacked duplicate banners: consecutive <p> (any depth under root) that only show
   * the same image src — common in HTML email + previously hidden by broken placeholder URLs.
   */
  private dedupeConsecutiveImageOnlyParagraphs(root: Element): void {
    const list = Array.from(root.querySelectorAll('p'));
    let prevImgSrc: string | null = null;
    for (const el of list) {
      if (!el.isConnected) {
        continue;
      }
      const imgs = el.querySelectorAll('img');
      if (imgs.length !== 1) {
        prevImgSrc = null;
        continue;
      }
      const text = (el.textContent || '').replace(/\s|[\u00a0]/g, '');
      if (text.length > 0) {
        prevImgSrc = null;
        continue;
      }
      const src = imgs[0].getAttribute('src') || '';
      if (src && src === prevImgSrc) {
        el.remove();
      } else {
        prevImgSrc = src;
      }
    }
  }

  private applyHtmlToQuill(html: string, alreadySanitized = false): void {
    if (!this.quill) {
      return;
    }
    const safe = alreadySanitized ? html || '' : this.sanitizeBodyHtmlForEditor(html || '');
    try {
      this.quill.setContents([]);
      this.quill.clipboard.dangerouslyPasteHTML(0, safe, 'silent');
    } catch (e) {
      try {
        this.quill.setText((html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim());
      } catch {
        /* ignore */
      }
    }
  }

  private initializeQuill() {
    const toolbarOptions = this.editorConfig.modules.toolbar;
    this.quill = new Quill('#emailEditor', {
      theme: 'snow',
      modules: {
        toolbar: toolbarOptions
      }
    });

    const initialContent = this.reminderMasterForm.get('Body').value;
    if (initialContent) {
      this.applyHtmlToQuill(initialContent, false);
    }

    // Update form value when content changes
    this.quill.on('text-change', () => {
      const content = this.quill.root.innerHTML;
      this.reminderMasterForm.get('Body').setValue(content);
    });

    // Add custom styles for the editor
    const style = document.createElement('style');
    style.textContent = `
      .ql-editor {
        min-height: 200px;
        font-family: Arial, sans-serif;
        font-size: 14px;
        line-height: 1.5;
        color: #333;
      }
      .ql-toolbar {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        background-color: #f8f9fa;
        border: 1px solid #ccc;
      }
      .ql-container {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        border: 1px solid #ccc;
        border-top: none;
      }
      .ql-editor strong {
        font-weight: bold !important;
      }
      .ql-editor b {
        font-weight: bold !important;
      }
      .ql-editor p {
        margin: 0;
        padding: 0;
      }
      .ql-editor .ql-bold {
        font-weight: bold !important;
      }
    `;
    document.head.appendChild(style);
  }

  loadEmailReminderData(emailReminderId: string) {
    this.emailReminderService.getEmailReminderById(emailReminderId)
      .subscribe((emailReminders: any) => {
        if (emailReminders.status === 0 && emailReminders.emailReminderData?.[0]) {
          const data = emailReminders.emailReminderData[0];
          const bodySafe = this.sanitizeBodyHtmlForEditor(data.Body || '');

          this.reminderMasterForm.patchValue({
            Title: data.Title || '',
            Subject: data.Subject || '',
            EmailText: data.EmailText || '',
            Body: bodySafe
          });

          const setEditorContent = (attempts: number) => {
            if (this.quill && bodySafe) {
              this.applyHtmlToQuill(bodySafe, true);
            } else if (bodySafe && attempts < 60) {
              setTimeout(() => setEditorContent(attempts + 1), 50);
            }
          };
          setEditorContent(0);

          // Disable Title field
          this.reminderMasterForm.get('Title').disable();

          // Set other data
          this.bodyKeyWords = data.BodyKeyWords || '';
          this.subjectKeyWords = data.SubjectKeyWords || '';
          this.mailReminderStaticID = data.MailReminderStaticID;
          this.emailReminderId = data._id;
          this.isDefault = data.IsDefault;
          this.IsUpsiEmail = data.IsUpsiEmail;
          this.IsSubjectKeyWordRequired = data.IsSubjectKeyWordRequired;
          this.IsBodyKeyWordRequired = data.IsBodyKeyWordRequired;
          this.DocumentFileDoc = data.FileNameUq;
          this.FileNameO = (data.FileNameUq) ? data.FileNameUq.slice(data.FileNameUq.indexOf("-") + 1) : "";
          
          // Set email values for multiple selections
          if (data.ToEmails?.length) {
            this.selectedToEmails = [...data.ToEmails];
            // Update available CC options
            this.availableCcOptions = this.availableOptions.filter(
              option => !this.selectedToEmails.includes(option)
            );
          }
          
          if (data.CcEmails?.length) {
            this.selectedCcEmails = [...data.CcEmails];
            // Update available To options
            this.availableToOptions = this.availableOptions.filter(
              option => !this.selectedCcEmails.includes(option)
            );
          }

          // Update UI elements
          $('#btnupdateReminder').show();
        }
      });
  }

  loadEmailReminderToEdit(emailReminderId: string) {
    this.loadEmailReminderData(emailReminderId);
  }

  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['emailReminderTemplates',this.type]  } }],
      { relativeTo: this.activatedRoute.parent });
  }

  draggableModelPopup() {
    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });
  }
  intializeDatatable() {
    // this.getReminderList()
    this.getReminderList(this.type);

  }
  getReminderList(type) {
    // console.log('it is coming here')
    
    try {
      $('#reminderTable').DataTable().destroy();
    } catch {
      /* no table or not initialized as DataTable */
    }
    this.emailReminderService.getEmailReminderList(type)
      .subscribe((reminderList:any) => {
        if (reminderList.status == 0) {
          this.reminders = [];
          this.reminders = reminderList.emailRemindersResult;
          this.dtTrigger.next();
        }
      })
  }

  fileChanged($event) {
    this.filesToUpload = $event.target.files[0];

  }
  downloadFile() {
    window.location.href = this.downloadURLForUPSI + this.DocumentFileDoc;
  }

  noSpecialCharactersValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value && /[!@#$%^&*,.?"'<>+=]/.test(value)) {
      // Return an error if special characters are found
      return { 'noSpecialCharacters': true };
    }
    // No special characters, validation passes
    return null;
  }
  checKkeyWordsAlert() {
    this.disabledOnclick = true;
    this.noSpecialCharactersValidator(this.reminderMasterForm);
    
    // Use the selected emails directly
    if (this.selectedCcEmails.length > 0) {
      this.CcEmails = [...this.selectedCcEmails];
    } else {
      if (this.emailReminderId == EmailIds.getEmailtemplate.EmailForAddedRecipient.emailtemplateId) {
        this.CcEmails = ['Data entry person', 'UPSI All data'];
      } else if (this.emailReminderId == EmailIds.getEmailtemplate.EmailForAddedUPSI.emailtemplateId) {
        this.CcEmails = ['Sharer', 'Data entry person', 'UPSI All data'];
      } else {
        this.CcEmails = ['Data entry person'];
      }
    }

    if (this.selectedToEmails.length > 0) {
      this.ToEmails = [...this.selectedToEmails];
    } else {
      if (this.emailReminderId == EmailIds.getEmailtemplate.EmailForAddedRecipient.emailtemplateId) {
        this.ToEmails = ['Recipient'];
      } else if (this.emailReminderId == EmailIds.getEmailtemplate.EmailForAddedUPSI.emailtemplateId) {
        this.ToEmails = ['Recipient'];
      } else {
        this.ToEmails = ['UPSI All data'];
      }
    }

    this.keywordsMissingSubjectAlert = false;
    this.keywordsMissingBodyAlert = false;
    this.missingSubjectKeywords = "";
    this.missingBodyKeywords = "";
    
    if (this.IsBodyKeyWordRequired || this.IsBodyKeyWordRequired == undefined) {
      const bodyKeywordsStr = String(this.bodyKeyWords);
      this.aryBodyKeyWords = bodyKeywordsStr.split(',').filter(Boolean);
      var bodyData = this.quill.root.innerHTML;
      
      for (var i = 0; i < this.aryBodyKeyWords.length; i++) {
        if (this.aryBodyKeyWords[i] && !(bodyData.indexOf(this.aryBodyKeyWords[i]) > -1)) {
          this.keywordsMissingBodyAlert = true;
          if (this.missingBodyKeywords == "")
            this.missingBodyKeywords = this.aryBodyKeyWords[i];
          else
            this.missingBodyKeywords = this.missingBodyKeywords + ',' + this.aryBodyKeyWords[i];
        }
      }
    }

    if (this.IsSubjectKeyWordRequired || this.IsSubjectKeyWordRequired == undefined) {
      const subjectKeywordsStr = String(this.subjectKeyWords);
      this.arySubjectKeyWords = subjectKeywordsStr.split(',').filter(Boolean);
      var subjectData = this.reminderMasterForm.controls.Subject.value;
      for (var i = 0; i < this.arySubjectKeyWords.length; i++) {
        if (!(subjectData.indexOf(this.arySubjectKeyWords[i]) > -1)) {
          this.keywordsMissingSubjectAlert = true;
          if (this.missingSubjectKeywords == "")
            this.missingSubjectKeywords = this.arySubjectKeyWords[i];
          else
            this.missingSubjectKeywords = this.missingSubjectKeywords + ',' + this.arySubjectKeyWords[i];
        }
      }
    }

    if (!this.keywordsMissingSubjectAlert && !this.keywordsMissingBodyAlert) {
      this.editReminder();
    }
    else {
      this.disabledOnclick = false;
      $('#confirmation').modal('toggle');
    }
  }

  editReminder() {
    var date = new Date();
    var timestamp = date.getTime();

    // Get the latest content from Quill editor
    const editorContent = this.quill ? this.quill.root.innerHTML : '';
    
    var updatedEmailRemnder = {
      MailReminderStaticID: this.mailReminderStaticID,
      BodyKeyWords: this.bodyKeyWords,
      SubjectKeyWords: this.subjectKeyWords,
      _id: this.emailReminderId,
      CompanyID: this.companyId,
      Body: editorContent, // Use the editor content directly
      Title: this.reminderMasterForm.controls.Title.value,
      Subject: this.reminderMasterForm.controls.Subject.value,
      IsDefault: this.isDefault,
      CcEmails: this.CcEmails,
      ToEmails: this.ToEmails,
      EmailText: this.reminderMasterForm.controls.EmailText.value,
      FileNameUq: (this.filesToUpload) ? timestamp + "-" + this.filesToUpload.name.replace(',', '') : null
    }

    if (!this.filesToUpload) {
      delete updatedEmailRemnder.FileNameUq;
    }

    if (this.isFileDeleted) {
      updatedEmailRemnder.FileNameUq = null
    }

    if (!this.isDefault) {
      this.emailReminderService.updateEmailReminder(updatedEmailRemnder)
        .subscribe(emailReminder => {
          this.disabledOnclick = false;
          if (emailReminder.status == 0) {
            if (this.filesToUpload) {
              this.makeFileRequest(environment.pssServerUrl + "upsi/EmailAttachment/" + this.emailReminderId, timestamp, [this.filesToUpload], 'UPSI')
            }
            this.showSuccessPopup = true;
            this.reminderMasterForm.reset();
          } else {
            this.alert.error(emailReminder.message);
          }
          this.getReminderList(this.type);
        });
    } else {
      this.emailReminderService.addEmailReminder(updatedEmailRemnder)
        .subscribe(emailReminder => {
          this.disabledOnclick = false;
          if (emailReminder.status == 0) {
            this.showSuccessPopup = true;
            this.reminderMasterForm.reset();
          } else {
            this.alert.error(emailReminder.message);
          }
          this.getReminderList(this.type);
        });
    }
  }
  onOkFunction(){
    this.showSuccessPopup = false;
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['emailReminderTemplates',this.type] } }],
      { relativeTo: this.activatedRoute.parent });
  }

  makeFileRequest(url: string, params: any, files, title: string) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var self = this;
      var xhr = new XMLHttpRequest();
      // console.log('files', files)
      for (var i = 0; i < files.length; i++) {
        formData.append("file", files[i], params + "-" + files[i].name.replace(',', ''));
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.setRequestHeader('userdetail', this.getUserDetail())
      xhr.setRequestHeader('pssdetail', localStorage.getItem("companyDetails"))
      xhr.send(formData);
    });
  }

  getUserDetail() {
    var user = JSON.parse(localStorage.getItem("user"));
    var resources = JSON.parse(localStorage.getItem("resources"));
    var companyDetails = JSON.parse(localStorage.getItem("companyDetailsGoveva"));
    var resourcesData = resources.filter(function (item) {
      return item.Menu === 'UPSI';
    })[0]

    var upsiAdmin;
    if (resourcesData) {
      upsiAdmin = (resourcesData['Menu']) ? true : false
    } else {
      upsiAdmin = false
    }

    var loginUser = {
      id: user._id,
      firstName: user.FirstName,
      lastName: user.LastName,
      upsiAdmin: upsiAdmin,
      EmailId: user.EmailId,
      companyDetails: companyDetails,
      title: user.Title
    }
    return JSON.stringify(loginUser);
  }

  ngOnDestroy() {
    if (this.routeParamSub) {
      this.routeParamSub.unsubscribe();
    }
    if (this.quill) {
      this.quill = null;
    }
  }

  // Add new methods for handling selections
  isValidEmail(email: string): boolean {
    if (!email || !email.trim()) {
      return false;
    }
    // Basic email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  }

  onToInputEnter(event: any) {
    event.preventDefault();
    const value = (event.target as HTMLInputElement).value.trim();
    this.toEmailError = ''; // Clear previous error
    
    if (value) {
      // Only allow if it's a valid email or from available options
      if (this.availableOptions.includes(value)) {
        // It's from dropdown, add it
        this.addToEmail(value);
      } else if (this.isValidEmail(value)) {
        // It's a valid custom email, add it
        this.addToEmail(value);
      } else {
        // Invalid email - show error message
        this.toEmailError = 'Please enter a valid email address';
        event.target.focus();
      }
    }
  }

  onToInputBlur(event: any) {
    // Delay to allow click events on dropdown to fire first
    setTimeout(() => {
      const value = (event.target as HTMLInputElement).value.trim();
      this.toEmailError = ''; // Clear previous error
      this.showToDropdown = false;
      
      // Only add if it's a valid email (for custom values) or from available options
      if (value) {
        if (this.availableOptions.includes(value)) {
          // It's from dropdown, add it
          this.addToEmail(value);
        } else if (this.isValidEmail(value)) {
          // It's a valid custom email, add it
          this.addToEmail(value);
        } else {
          // Invalid email - show error message
          this.toEmailError = 'Please enter a valid email address';
        }
      }
      // Set readonly again after blur
      const input = event.target as HTMLInputElement;
      if (input) {
        input.setAttribute('readonly', 'readonly');
      }
    }, 200);
  }

  toggleToDropdown() {
    this.showToDropdown = !this.showToDropdown;
    if (this.showToDropdown) {
      // Remove readonly to allow typing
      setTimeout(() => {
        const input = document.querySelector('.emailTo') as HTMLInputElement;
        if (input) {
          input.removeAttribute('readonly');
          input.focus();
        }
      }, 0);
    } else {
      // Close dropdown and restore readonly
      const input = document.querySelector('.emailTo') as HTMLInputElement;
      if (input && !input.value) {
        input.setAttribute('readonly', 'readonly');
      }
    }
  }

  selectToOption(option: string) {
    this.addToEmail(option);
    this.showToDropdown = false;
    this.toInputValue = '';
    // Restore readonly after selection
    setTimeout(() => {
      const input = document.querySelector('.emailTo') as HTMLInputElement;
      if (input) {
        input.setAttribute('readonly', 'readonly');
      }
    }, 0);
  }

  onToInputChange(event: any) {
    this.toInputValue = (event.target as HTMLInputElement).value;
    // Clear error when user starts typing
    if (this.toEmailError) {
      this.toEmailError = '';
    }
    // Show dropdown when typing
    if (this.toInputValue && !this.showToDropdown) {
      this.showToDropdown = true;
    }
  }

  onToSelectionChange(event: any) {
    const selectedValue = event.target.value;
    if (!this.selectedToEmails.includes(selectedValue)) {
      this.selectedToEmails.push(selectedValue);
      // Remove from CC options
      this.availableCcOptions = this.availableCcOptions.filter(option => option !== selectedValue);
    }
    // Reset select element
    event.target.value = '';
  }

  // CC field input handlers
  onCcInputEnter(event: any) {
    event.preventDefault();
    const value = (event.target as HTMLInputElement).value.trim();
    this.ccEmailError = ''; // Clear previous error
    
    if (value) {
      // Only allow if it's a valid email or from available options
      if (this.availableOptions.includes(value)) {
        // It's from dropdown, add it
        this.addCcEmail(value);
      } else if (this.isValidEmail(value)) {
        // It's a valid custom email, add it
        this.addCcEmail(value);
      } else {
        // Invalid email - show error message
        this.ccEmailError = 'Please enter a valid email address';
        event.target.focus();
      }
    }
  }

  onCcInputBlur(event: any) {
    // Delay to allow click events on dropdown to fire first
    setTimeout(() => {
      const value = (event.target as HTMLInputElement).value.trim();
      this.ccEmailError = ''; // Clear previous error
      this.showCcDropdown = false;
      
      // Only add if it's a valid email (for custom values) or from available options
      if (value) {
        if (this.availableOptions.includes(value)) {
          // It's from dropdown, add it
          this.addCcEmail(value);
        } else if (this.isValidEmail(value)) {
          // It's a valid custom email, add it
          this.addCcEmail(value);
        } else {
          // Invalid email - show error message
          this.ccEmailError = 'Please enter a valid email address';
        }
      }
      // Set readonly again after blur
      const input = event.target as HTMLInputElement;
      if (input) {
        input.setAttribute('readonly', 'readonly');
      }
    }, 200);
  }

  toggleCcDropdown() {
    this.showCcDropdown = !this.showCcDropdown;
    if (this.showCcDropdown) {
      // Remove readonly to allow typing
      setTimeout(() => {
        const input = document.querySelector('.emailCC') as HTMLInputElement;
        if (input) {
          input.removeAttribute('readonly');
          input.focus();
        }
      }, 0);
    } else {
      // Close dropdown and restore readonly
      const input = document.querySelector('.emailCC') as HTMLInputElement;
      if (input && !input.value) {
        input.setAttribute('readonly', 'readonly');
      }
    }
  }

  selectCcOption(option: string) {
    this.addCcEmail(option);
    this.showCcDropdown = false;
    this.ccInputValue = '';
    // Restore readonly after selection
    setTimeout(() => {
      const input = document.querySelector('.emailCC') as HTMLInputElement;
      if (input) {
        input.setAttribute('readonly', 'readonly');
      }
    }, 0);
  }

  onCcInputChange(event: any) {
    this.ccInputValue = (event.target as HTMLInputElement).value;
    // Clear error when user starts typing
    if (this.ccEmailError) {
      this.ccEmailError = '';
    }
    // Show dropdown when typing
    if (this.ccInputValue && !this.showCcDropdown) {
      this.showCcDropdown = true;
    }
  }

  onCcSelectionChange(event: any) {
    const selectedValue = event.target.value;
    if (!this.selectedCcEmails.includes(selectedValue)) {
      this.selectedCcEmails.push(selectedValue);
      // Remove from To options
      this.availableToOptions = this.availableToOptions.filter(option => option !== selectedValue);
    }
    // Reset select element
    event.target.value = '';
  }

  addToEmail(value: string) {
    try {
      const trimmedValue = value ? value.trim() : '';
      if (trimmedValue && !this.selectedToEmails.includes(trimmedValue)) {
        this.selectedToEmails.push(trimmedValue);
        // Don't remove from availableToOptions - let the getter filter it out
        // This way items can reappear when removed from selected list
        // Only remove from CC options if it's a predefined option (for consistency)
        if (this.availableCcOptions && this.availableCcOptions.includes(trimmedValue)) {
          this.availableCcOptions = this.availableCcOptions.filter(option => option !== trimmedValue);
        }
      }
      this.toInputValue = '';
      // Clear the input field
      setTimeout(() => {
        const $input = $('.emailTo');
        if ($input.length) {
          $input.val('');
        }
      }, 0);
    } catch (error) {
      // console.error('Error adding email:', error);
    }
  }

  addCcEmail(value: string) {
    try {
      const trimmedValue = value ? value.trim() : '';
      if (trimmedValue && !this.selectedCcEmails.includes(trimmedValue)) {
        this.selectedCcEmails.push(trimmedValue);
        // Don't remove from availableCcOptions - let the getter filter it out
        // This way items can reappear when removed from selected list
        // Only remove from To options if it's a predefined option (for consistency)
        if (this.availableToOptions && this.availableToOptions.includes(trimmedValue)) {
          this.availableToOptions = this.availableToOptions.filter(option => option !== trimmedValue);
        }
      }
      this.ccInputValue = '';
      // Clear the input field
      setTimeout(() => {
        const $input = $('.emailCC');
        if ($input.length) {
          $input.val('');
        }
      }, 0);
    } catch (error) {
      // console.error('Error adding CC email:', error);
    }
  }

  removeToEmail(email: string) {
    this.selectedToEmails = this.selectedToEmails.filter(e => e !== email);
    // Add back to To options if it's in the original availableOptions
    if (this.availableOptions.includes(email) && !this.availableToOptions.includes(email)) {
      this.availableToOptions.push(email);
      this.availableToOptions.sort();
    }
    // Add back to CC options if it's in the original availableOptions
    if (this.availableOptions.includes(email) && !this.availableCcOptions.includes(email)) {
      this.availableCcOptions.push(email);
      this.availableCcOptions.sort();
    }
  }

  removeCcEmail(email: string) {
    this.selectedCcEmails = this.selectedCcEmails.filter(e => e !== email);
    // Add back to To options if it's in the original availableOptions
    if (this.availableOptions.includes(email) && !this.availableToOptions.includes(email)) {
      this.availableToOptions.push(email);
      this.availableToOptions.sort();
    }
    // Add back to CC options if it's in the original availableOptions
    if (this.availableOptions.includes(email) && !this.availableCcOptions.includes(email)) {
      this.availableCcOptions.push(email);
      this.availableCcOptions.sort();
    }
  }
}
